import styled from 'styled-components'

export const StyledMenuItensList = styled.div`
    .sort-dropdown-toggle {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 32px;
        height: 32px;

        border: 1px solid var(--gray-400);
        border-radius: 3px;

        color: var(--text-color);
        background-color: var(--gray-lighter);

        &:hover {
            background-color: var(--gray-300);
        }

        .fa-sort-alt {
            color: var(--blue-500);
        }
    }

    ul {
        list-style: none;

        .dropdown-menu-item-arrow.active > a {
            color: var(--blue-500);

            :hover {
                color: var(--blue-500);
            }
        }
    }
`
